<template>
  <section class="content-container pb-5 mb-5" id="ResultReport">
    <div class="row d-flex flex-row flex-wrap align-items-stretch">
      <div
        v-for="(item, i) in report_items"
        :key="i"
        class="col-12 col-md-6 col-lg-4 text-center pb-5"
      >
        <div class="report-item-card h-100">
          <div class="report-item-card-heading">
            <h4 class="report-item-card-heading mx-0 px-0">
              {{ item.heading }}
            </h4>
          </div>
          <div class="report-item-card-body px-4">
            <h4 class="report-item-card-title py-4" v-if="item.title">
              {{ item.title }}
            </h4>
            <p v-html="item.description"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["report_items"]
};
</script>

<style lang="less">
#ResultReport {
  .report-item-card {
    display: flex;
    flex-direction: column;
  }
  .report-item-card-body {
    flex: 1;
    flex-grow: 1;
    font-size: 1.6rem;
    padding: 10px;
    background-color: white;
  }
  .report-item-card-heading {
    background-color: #5c5cb7;
    color: white;
    padding: 10px;
  }
}
</style>
